export enum PointField {
    KEY_TYPE = 'type',
    KEY_ID = '_id',
    KEY_POLYGON_ID = 'polygon_id',
    KEY_POINT_ID = 'point_id',
    KEY_NEXT_POINT_ID = 'next_point_id',
    KEY_PREV_POINT_ID = 'prev_point_id',
    KEY_INDEX = 'p_index',
    KEY_LAT = 'latitude',
    KEY_LONG = 'longitude',
    KEY_ALT = 'altitude',
    KEY_ALT_3D = 'altitude_3d',
    KEY_DESCRIPTION = 'description',
    KEY_DESC_LAT = 'desc_latitude',
    KEY_DESC_LONG = 'desc_longitude',
    KEY_SHOW_IN_REPORT = 'show_in_report',
    KEY_SHOW_DESC = 'show_desc',
    KEY_IMAGES = 'images',
    KEY_SHOW_LABEL_BACKGROUND = 'show_label_background',
}
